import React from 'react';

import { ThemeProvider, styled } from 'styled-components';
import { theme } from '../theme/aikya';
import { useElementVisibility } from '../hooks/useElementVisibility';

import { Header } from './Header';
import { ContactBlock } from './ContactBlock';
import { SupportBlock } from './SupportBlock';
import { ServalHeaderBlock } from './ServalHeaderBlock';
import { ServalTextBlock } from './ServalTextBlock';
import { ServalSpecBlock } from './ServalSpecBlock';
import { ServalImagesBlock } from './ServalImagesBlock';
import { ServalExplodedViewBlock } from './ServalExplodedViewBlock';
import { ServalBuildBlock } from './ServalBuildBlock';
import { FooterSection } from './FooterSection';
import { ServalSecondaryHeader } from './ServalSecondaryHeader';
import { InfoBlock } from './InfoBlock';

const ServalPageWrapper = styled.div`
    margin-top: 3rem;
    height: calc(100vh - 3rem);
    overflow-y: scroll;
    scroll-snap-type: y proximity;

	@media only screen and (orientation:landscape) {
		scroll-snap-type: none;
	}
`;

export const ServalPage = () => {
	const { elementRef: servalHeaderRef, isHidden } = useElementVisibility();

	return (
		<ThemeProvider theme={theme}>
			<Header />
			<ServalSecondaryHeader isVisible={isHidden} />
			<ServalPageWrapper>
				<ServalHeaderBlock ref={servalHeaderRef} />
				<ServalTextBlock />
				<InfoBlock productId="serval" />
				<ServalSpecBlock />
				<ServalExplodedViewBlock />
				<ServalImagesBlock />
				<ServalBuildBlock />
				<ContactBlock />
				<SupportBlock />
				<FooterSection />
			</ServalPageWrapper>
		</ThemeProvider>
	)
}